<template>
  <div style="position: relative;">
    <el-container>
        <el-header height="64px">
          <div style="display: flex">
            <!--                <div style="height: 64px">-->
            <!--                    <img style="margin: 16px 0;height: 32px;cursor: pointer;" @click="$router.push({name: 'Index'})"-->
            <!--                         src="https://play-lh.googleusercontent.com/2gUfdZFzMqqTBflaw-fZCjWbl2iKNn24lQP1yi_ucG6egXbmsavvMS_cDMF-zaUgGBAz=w240-h480-rw">-->
            <!--                </div>-->
            <!--                <div style="padding: 0 10px;line-height: 64px;font-size: 20px;color: var(&#45;&#45;el-text-color-regular);">-->
            <!--                    ClassicJigsaw-->
            <!--                    <el-divider direction="vertical" style="font-size: 32px"></el-divider>-->
            <!--                </div>-->
            <div class="product" v-if="product">
              <el-image :src="product.avatar" lazy style="width: 32px;cursor: pointer;margin: 16px 0;border-radius: 5px"></el-image>
              <el-popover placement="bottom" trigger="click" width="350px" ref="popover">
                <template #default>
                  <!--                    <el-input size="small" prefix-icon="Search" placeholder="产品搜索"-->
                  <!--                              v-model="query" ref="search"></el-input>-->
                  <el-scrollbar max-height="300px">
                    <div v-for="p in getProductList()" :key="p.id" @click="switchProduct(p)">
                      <div class="product-nav"
                           :style="{backgroundColor: p.key===product.key?'var(--el-border-color-lighter)': ''}">
                        <img :src="p.avatar" style="width: 40px;border-radius: 5px">
                        <div style="margin-left: 15px;white-space: nowrap;width: 280px">
                          <el-row style="line-height: 40px;font-size: 16px;">
                            {{ p.name }}
                            <!--                              ({{ p.platform === 'ios' ? 'iOS' : 'Android' }})-->
                          </el-row>
                          <!--                            <el-row style="line-height: 16px;font-size: 12px;">-->
                          <!--                              {{ p.app_id }}-->
                          <!--                            </el-row>-->
                        </div>
                      </div>
                    </div>
                  </el-scrollbar>
                </template>
                <template #reference>
                        <span style="margin-left: 10px;cursor: pointer;padding: 0 10px;line-height: 64px;font-size: 20px;color: var(--el-text-color-regular);">
                            {{ product.name }}
                            <el-icon size="14px">
                                <CaretBottom/>
                            </el-icon>
                        </span>
                </template>
              </el-popover>
            </div>
          </div>


          <div class="dark-switcher">
            <el-switch style="margin: 16px" v-model="dark" @change="changeDark"
                       active-action-icon="Moon" inactive-action-icon="Sunny"></el-switch>
            <el-button size="small" type="text" @click="logout()">退出登录</el-button>
          </div>
        </el-header>
        <el-container :style="{height: height + 'px'}" style="background-color: var(--el-border-color-extra-light)">
            <aside-nav ref="nav">
	                <aside-group title="素材库">
	                    <aside-item v-if="hasFeature('material')" icon="Files" title="全局图库" index="Index"></aside-item>
	                    <aside-item v-if="hasFeature('tag')" icon="PriceTag" title="标签管理" index="Tag"></aside-item>
	                    <aside-item v-if="hasFeature('tag')" icon="ChatDotRound" title="AI 标签反馈" index="AiTagFeedback"></aside-item>
	                    <aside-item v-if="hasFeature('score')" icon="Star" title="素材评分" index="Score"></aside-item>
	                    <aside-item v-if="hasFeature('metric')" icon="Clock" title="每日表现" index="Metric"></aside-item>
	                    <aside-item v-if="hasFeature('metric')" icon="Document" title="周报" index="WeeklyReport"></aside-item>
<!--                    <aside-item icon="Star" title="日本数据" index="JPScore"></aside-item>-->
                </aside-group>
	                <aside-group title="图库页">
	                    <aside-item v-if="hasFeature('category')" icon="Reading" title="分类管理" index="Category"></aside-item>
	                    <aside-item v-if="hasFeature('update')" icon="Calendar" title="每日更新" index="Update"></aside-item>
<!--                        <aside-item icon="Checked" title="新手引导" index="Rookie"></aside-item>-->
	                    <aside-item v-if="hasFeature('carousel')" icon="Orange" title="轮播图" index="Carousel"></aside-item>
	                    <aside-item v-if="hasFeature('suspend')" icon="HelpFilled" title="悬浮按钮" index="Suspend"></aside-item>
	                    <aside-item v-if="hasFeature('popup')" icon="Monitor" title="弹窗" index="Popup"></aside-item>
<!--                    <aside-item icon="QuestionFilled" title="问号图封面" index="MagicCover"></aside-item>-->
                </aside-group>
	                <aside-group title="发现页">
	                    <aside-item v-if="hasFeature('daily')" icon="Calendar" title="盲盒" index="Daily"></aside-item>
	                    <aside-item v-if="hasFeature('collection')" icon="Collection" title="集合" index="Collection"></aside-item>
	                    <aside-item v-if="hasFeature('magic_collection')" icon="Memo" title="抽卡集合" index="MagicCollection"></aside-item>
	                    <aside-item v-if="hasFeature('story_collection')" icon="Notebook" title="故事集合" index="StoryCollection"></aside-item>
	                    <aside-item v-if="hasFeature('collection_sort')" icon="Sort" title="集合排序" index="CollectionSort"></aside-item>
                </aside-group>
	                <aside-group v-if="hasFeature('achievement')" title="运营活动">
	                    <aside-item icon="Medal" title="成就图片资源" index="AchievementConfig"></aside-item>
	                </aside-group>
<!--                    <aside-group title="Match页">-->
<!--                        <aside-item icon="User" title="头像管理" index="Avatar"></aside-item>-->
<!--                    </aside-group>-->
	                <aside-group title="内容推荐">
	                    <aside-item v-if="hasFeature('library_recommend')" index="LibraryRecommend" title="首页推荐" icon="FolderAdd"></aside-item>
	                    <aside-item v-if="hasFeature('recommend_frequency')" index="RecommendFrequency" title="推荐频次" icon="DataLine"></aside-item>
	                    <aside-item v-if="hasFeature('country_hot')" index="CountryHot" title="国家热图" icon="HotWater"></aside-item>
	                    <aside-item v-if="hasFeature('country_rookie')" index="CountryRookie" title="国家新手图" icon="Checked"></aside-item>
	                    <aside-item v-if="hasFeature('country_manual')" index="CountryManual" title="手动新手图" icon="FolderAdd"></aside-item>
	                </aside-group>
	                <aside-group title="内购">
	                    <aside-item v-if="hasFeature('iap')" index="IAP" title="内购页布局" icon="Document"></aside-item>
	                    <aside-item v-if="hasFeature('subscription')" index="Subscription" title="订阅活动" icon="Goods"></aside-item>
	                    <aside-item v-if="hasFeature('newbie_sales')" index="NewbieSales" title="新用户活动" icon="Goods"></aside-item>
	                </aside-group>
	                <aside-group v-if="hasFeature('transsion')" title="传音">
                  <aside-item icon="Files" title="图库" index="TranssionImage"></aside-item>
                  <aside-item icon="FolderAdd" title="新手图" index="TranssionRookie" ></aside-item>
                  <aside-item icon="Calendar" title="每日更新" index="TranssionUpdate"></aside-item>
                  <aside-item icon="Reading" title="分类管理" index="TranssionCategory"></aside-item>
                  <aside-item icon="Clock" title="每日表现" index="TranssionPerformance"></aside-item>
                </aside-group>
	                <aside-group title="工具">
	                    <aside-item v-if="showClassicImport" icon="Upload" title="Classic导入" index="ClassicImport"></aside-item>
	                </aside-group>
	                <aside-group v-if="hasFeature('find_difference') || hasFeature('match') || hasFeature('avatar')" title="玩法">
<!--                        <aside-item index="Match" title="Match" icon="SwitchFilled"></aside-item>-->
	                    <aside-item v-if="hasFeature('find_difference')" index="FindDifference" title="找不同" icon="Search"></aside-item>
	                    <aside-item v-if="hasFeature('find_difference')" index="FindDifferenceImage" title="找不同-图库" icon="Files"></aside-item>
	                    <aside-item v-if="hasFeature('match')" icon="Collection" title="Match" index="Match"></aside-item>
	                    <aside-item v-if="hasFeature('avatar')" icon="Avatar" title="Match-头像" index="Avatar"></aside-item>
                </aside-group>
<!--                <aside-group title="游戏中心">-->
<!--                  <aside-item icon="Grid" title="首页游戏" index="Game"></aside-item>-->
<!--                  <aside-item icon="Coin" title="游戏任务" index="GameTask"></aside-item>-->
<!--                </aside-group>-->
            </aside-nav>
            <el-main>
                <el-scrollbar>
                    <router-view></router-view>
                </el-scrollbar>
            </el-main>
        </el-container>
      </el-container>
    </div>
</template>
<script>
import {useDark, useToggle} from '@vueuse/core'
import AsideNav from "./base/AsideNav";
import AsideItem from "./base/AsideItem";
import AsideGroup from "./base/AsideGroup";
import { CaretBottom } from '@element-plus/icons-vue'
import axios from "ts-axios-new";
import {changeProduct, getProduct, getProductList} from "./libs/app";
import {isClassicImportGateEnabled} from "./components/ClassicImport.vue";

export default {
    name: 'App',
    components: {AsideGroup, AsideItem, AsideNav, CaretBottom},
    data() {
        return {
            height: document.documentElement.clientHeight - 64,
            width: document.documentElement.clientWidth,
            dark: window.matchMedia('(prefers-color-scheme: dark)').matches,
            country_list: [], cdn_url: import.meta.env.VITE_CDN_URL,
            image_module_enum: {"LIBRARY": '图库', "COLLECTION": '集合', "DAILY": '每日', "EVENT": '运营活动'},
            product: null,
        }
    },
	    computed: {
	        showClassicImport() {
	            return this.hasFeature('classic_import') && isClassicImportGateEnabled(this.$route);
	        },
    },
    methods: {
      getProduct,
      getProductList,
        init() {

        },
        changeDark() {
            useToggle(useDark())(this.dark);
        },
        handleScroll() {
            this.height = document.documentElement.clientHeight - 64;
            this.width = document.documentElement.clientWidth;
        },
	        switchProduct(p) {
	          this.product = p
	          changeProduct(p)
	          this.$refs.popover.hide()
	          location.reload();
	        },
	        hasFeature(feature) {
	          const product = this.product || getProduct();
	          const features = product && product.features ? product.features : {};
	          if (features[feature] !== undefined) {
	            return features[feature] !== false;
	          }
	          const fantasyOnly = ['library_recommend', 'recommend_frequency', 'country_hot', 'country_rookie', 'transsion', 'find_difference', 'match', 'avatar', 'achievement'];
	          if (fantasyOnly.includes(feature)) {
	            return product && product.key === 'fantasy';
	          }
	          if (feature === 'classic_import') {
	            return product && product.key === 'classic';
	          }
	          return true;
	        },
	        logout() {
          axios.get(`/cms/v1/logout`).then(_ => {
            location.reload();
          })
        },
    },
    mounted() {
        window.onresize = _ => {
            this.handleScroll();
        };
        this.init();
        this.changeDark();
        const media = window.matchMedia('(prefers-color-scheme: dark)');
        media.addEventListener('change', e => {
            this.dark = e.matches;
            this.changeDark();
        });
        axios.get('https://console.plutodesk.com/api/v1/country').then(res => {
            this.country_list = res.data.data.countryList;
        });
        this.product = getProduct()
    }
}
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
}

.el-header {
  display: flex;
  padding: 0 20px;
  justify-content: space-between;
  border-bottom: solid 1px var(--el-border-color-light);
  background-color: var(--el-bg-color);
}
</style>
<style scoped>
.dark-switcher ::v-deep(.el-switch__action) {
  color: #000 !important;
}
.dark-switcher ::v-deep(.el-switch.is-checked .el-switch__core) {
  background-color: #444;
  border-color: #444;
}


.el-aside, .product-nav:hover {
  background-color: var(--el-border-color-extra-light);
  color: var(--el-text-color-secondary);
}

.product {
  font-size: 20px;
  line-height: 64px;
  display: flex;
  /*white-space: nowrap;*/
  /*overflow: hidden;*/
}

.product-nav {
  padding: 7px 5px;
  position: relative;
  cursor: pointer;
  display: flex;
}

</style>
<!--<style>-->
<!--<style scoped>-->
<!--body {-->
<!--    margin: 0;-->
<!--    padding: 0;-->
<!--}-->

<!-- .dark-switcher ::v-deep(.el-switch__action) {-->
<!--   color: #000 !important;-->
<!-- }-->
<!--.dark-switcher ::v-deep(.el-switch.is-checked .el-switch__core) {-->
<!--  background-color: #444;-->
<!--  border-color: #444;-->
<!--}-->


<!--.el-aside, .product-nav:hover {-->
<!--  background-color: var(&#45;&#45;el-border-color-extra-light);-->
<!--  color: var(&#45;&#45;el-text-color-secondary);-->
<!--}-->

<!--.product {-->
<!--  font-size: 20px;-->
<!--  line-height: 64px;-->
<!--  display: flex;-->
<!--  /*white-space: nowrap;*/-->
<!--  /*overflow: hidden;*/-->
<!--}-->

<!--.product-nav {-->
<!--  padding: 7px 5px;-->
<!--  position: relative;-->
<!--  cursor: pointer;-->
<!--  display: flex;-->
<!--}-->

<!--</style>-->
